import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { checkStoreState, setInitialStoreState } from '../../../../../common/utils';
import { TransportPlannerProfileItemBriefFacade } from './transport-planner-profile-item-brief.facade';

@Injectable({
  providedIn: 'root',
})
export class TransportPlannerProfileItemBriefGuard {
  constructor(private transportPlannerProfileItemBriefFacade: TransportPlannerProfileItemBriefFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { transportPlannerProfileId },
    } = route;
    return checkStoreState(this.transportPlannerProfileItemBriefFacade, transportPlannerProfileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.transportPlannerProfileItemBriefFacade);
  }
}
